// import axios from 'axios'
import ApiHandler from './api-handler.service'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL
class FileService {
 
  uploadFile (data, onProgress) {
    return ApiHandler.uploadCall(API_URL + '/file', data, ApiHandler.ShowAlert, ApiHandler.ShowAlert, onProgress)
  }
}
export default new FileService()
